import { useCallback, useEffect, useState } from "react";
import axios from "../../../axios";
import * as S from "../Funnel/Funnel.styled";

// Оголошення вчителям через бот вчителів (@speaksy_teachers_bot): той самий бот, куди приходять запити на пробні.
// Перевірка — у чат менеджерів «Speaksy Trial Teachers» (адмін не підключений до цього бота як вчитель).
const plain = (html) => String(html || "").replace(/<[^>]+>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&amp;/g, "&");
const copyText = async (text) => {
  try { await navigator.clipboard.writeText(text); return true; } catch { window.prompt("Скопіюйте повідомлення:", text); return false; }
};
const when = (d) => (d ? new Date(d).toLocaleString("uk-UA", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
const LANG = { en: "англ.", de: "нім." };

function TeacherBroadcasts() {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [text, setText] = useState("");
  const [segment, setSegment] = useState("all");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState("");
  const [copied, setCopied] = useState("");

  const load = useCallback(() => {
    axios.get("admin/teacher-bot").then((r) => setInfo(r.data)).catch(() => setError("Не вдалося завантажити дані бота вчителів"));
  }, []);
  useEffect(() => { load(); }, [load]);

  const recipients = (key) => info?.segments?.[key]?.chats ?? 0;
  const describe = (d) => [
    `доставлено ${d.delivered} з ${d.total}`,
    d.blocked ? `заблокували бота: ${d.blocked}` : "",
    d.failed ? `не надіслано: ${d.failed}${d.error ? ` (${d.error})` : ""}` : "",
  ].filter(Boolean).join(" · ");
  const send = async (test) => {
    if (!text.trim()) return setResult("Напишіть повідомлення");
    if (!test && !window.confirm(`Надіслати оголошення ${recipients(segment)} вчителям («${info.segments[segment].label}»)?`)) return;
    setBusy(true); setResult("");
    try {
      const { data } = await axios.post("admin/teacher-bot/broadcast", { segment, text, test });
      const ok = data.delivered > 0 && !data.failed;
      setResult(test
        ? (ok ? "✅ Надіслано в чат менеджерів «Speaksy Trial Teachers» — перевірте, як виглядає." : `⚠️ Не дійшло: ${describe(data)}`)
        : `${ok ? "✅" : "⚠️"} ${describe(data)}`);
      load();
    } catch (e) {
      setResult("⚠️ " + (e?.response?.data?.message || "Не вдалося надіслати"));
    } finally {
      setBusy(false);
    }
  };
  const copyInvite = async (t) => {
    try {
      const { data } = await axios.post(`admin/teacher-bot/invite/${t._id}`);
      await copyText(data.text);
      setCopied(t._id);
    } catch (e) {
      setResult("⚠️ " + (e?.response?.data?.message || "Не вдалося створити посилання"));
    }
  };

  if (error) return <S.ErrorText>{error}</S.ErrorText>;
  if (!info) return null;
  if (!info.enabled) return <S.Card><S.Empty>Бот вчителів ще не підключений на сервері.</S.Empty></S.Card>;
  const notLinked = info.teachers.filter((t) => !t.linked);

  return (
    <>
      <S.Card>
        <S.CardHead>
          <div>
            <S.H>Оголошення вчителям</S.H>
            <S.Hint>Через бот, куди вчителям приходять запити на пробні. Підключили бота: <b>{info.teachers.length - notLinked.length}</b> з {info.teachers.length}</S.Hint>
          </div>
        </S.CardHead>

        <S.Small style={{ fontWeight: 700, marginBottom: 6 }}>Готові шаблони (можна редагувати)</S.Small>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
          {info.templates.map((t) => <S.Btn key={t.id} $ghost onClick={() => { setText(t.text); setResult(""); }}>{t.title}</S.Btn>)}
        </div>

        <textarea
          value={text}
          onChange={(e) => { setText(e.target.value); setResult(""); }}
          placeholder="Текст оголошення. Жирний: <b>текст</b>"
          rows={7}
          style={{ width: "100%", boxSizing: "border-box", font: "inherit", padding: 12, borderRadius: 10, border: "1px solid #dcd7ee", resize: "vertical" }}
        />
        <S.Hint style={{ textAlign: "right", marginTop: 4 }}>{text.length} / 3500</S.Hint>

        <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: "0.85rem", fontWeight: 700, margin: "10px 0" }}>
          Кому
          <S.Select value={segment} onChange={(e) => setSegment(e.target.value)}>
            {Object.entries(info.segments).map(([k, v]) => <option key={k} value={k}>{v.label} — {recipients(k)}</option>)}
          </S.Select>
        </label>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <S.Btn $ghost disabled={busy} onClick={() => send(true)}>Надіслати в чат менеджерів на перевірку</S.Btn>
          <S.Btn disabled={busy || recipients(segment) === 0} onClick={() => send(false)}>{busy ? "Надсилаю…" : `Надіслати (${recipients(segment)})`}</S.Btn>
        </div>
        {result && <S.Hint style={{ marginTop: 10, fontWeight: 700 }}>{result}</S.Hint>}
      </S.Card>

      {notLinked.length > 0 && (
        <S.Card>
          <S.CardHead>
            <div>
              <S.H>Ще не підключили бота — {notLinked.length}</S.H>
              <S.Hint>Оголошення до них не дійдуть. «📋 Повідомлення» копіює текст з особистим посиланням — надішліть вчителю, він натисне Start.</S.Hint>
            </div>
          </S.CardHead>
          <S.List style={{ maxHeight: 420, overflowY: "auto" }}>
            {notLinked.map((t) => (
              <li key={t._id} style={{ alignItems: "center", flexWrap: "wrap" }}>
                <span><b>{t.name}</b> <S.Hint as="span" style={{ margin: 0 }}>ID {t.teacherId} · {LANG[t.accessType] || t.accessType}</S.Hint></span>
                <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
                  {t.botBlocked && <S.Tag $c="red">заблокував бота</S.Tag>}
                  <S.Btn $ghost onClick={() => copyInvite(t)}>{copied === t._id ? "✅ Скопійовано" : "📋 Повідомлення"}</S.Btn>
                </span>
              </li>
            ))}
          </S.List>
        </S.Card>
      )}

      <S.Card>
        <S.CardHead><S.H>Історія оголошень</S.H></S.CardHead>
        {info.history.length === 0 ? <S.Empty>Ще не було оголошень</S.Empty> : (
          <S.List>
            {info.history.map((h) => (
              <li key={h._id}>
                <span>{when(h.createdAt)} · <b>{h.test ? "перевірка" : info.segments[h.segment]?.label || h.segment}</b>
                  <S.Hint style={{ margin: 0 }}>{plain(h.text).slice(0, 90)}{plain(h.text).length > 90 ? "…" : ""}</S.Hint>
                  {h.error && <S.Hint style={{ margin: 0, color: "#c0392b" }}>Не дійшло: {h.error}</S.Hint>}
                </span>
                <S.Tag $c={h.failed || h.blocked ? "amber" : "green"}>{h.delivered}/{h.total}</S.Tag>
              </li>
            ))}
          </S.List>
        )}
      </S.Card>
    </>
  );
}

export default TeacherBroadcasts;
